import React from 'react'
import CustomDialog from './CustomDialog'
import ButtonContained from './ButtonContained'
import CommonFileUpload from './CommonFileUpload'
import { Box, Grid, useTheme } from '@mui/material'
import Assets from './Assets'
import { BucketURL } from '../../ApiSetup/Api'
import TextLabel from './CommonTextLabel'

const ReUploadModal = ({ open, handleClose, onSave, name, onChange, text, imageValue, multiple }) => {
    const theme = useTheme();
    return (
        <>
            {open && <CustomDialog
                isOpen={open} handleClose={handleClose}
                title={
                    <Box display={"flex"} flexDirection={"column"}>
                        {text}
                        <TextLabel fontSize={"12px"} color='#ed6c02' title="નોંધ : કૃપા કરીને સ્પષ્ટ છબી અપલોડ કરો" fontWeight={400} />
                    </Box>

                } padding={'10px'}
                width={400}
                // action={
                //     <>
                //         <ButtonContained
                //             text={'Save'}
                //             onClick={onSave}
                //             minWidth={'100%'}
                //             marginTop={'10px'}
                //         />
                //     </>
                // }
            >
                <Grid container spacing={2} xs={12}>
                    <Grid item xs={12}>
                        <CommonFileUpload
                            multiple={multiple}
                            valid
                            // text={text}
                            labelColor={theme?.palette?.primary?.main}
                            labelTitle="image/jpeg, image/png and image/jpg up to 5MB"
                            name={name} // This is the key that will be logged in handleUpload
                            onChange={onChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {imageValue?.length > 0 &&
                            <Box display={'flex'} flexWrap={'wrap'} gap={1}>
                                {imageValue?.map((val) => {
                                    return (<Assets src={BucketURL + val} height={'50px'} width={'50px'} />)
                                })}
                            </Box>}
                    </Grid>
                </Grid>
            </CustomDialog>}
        </>
    )
}

export default ReUploadModal
